document.addEventListener('DOMContentLoaded', function() {
  const radarForms = document.querySelectorAll('.koji-radar-form');

  // CREAZIONE DELL'IFRAME FANTASMA (Per ingannare Shopify e inviare la mail in sicurezza)
  const iframeName = 'koji-hidden-iframe';
  let iframe = document.getElementById(iframeName);
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.id = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
  }

  radarForms.forEach(radarForm => {
    // Indirizziamo l'invio del modulo nell'iframe fantasma!
    radarForm.setAttribute('target', iframeName);

    let isSubmitting = false;

    radarForm.addEventListener('submit', function(e) {
      const radarInput = radarForm.querySelector('.koji-radar-input');
      const submitBtn = radarForm.querySelector('.koji-radar-submit');
      
      const inputValue = radarInput.value.trim();
      
      if (inputValue === '') {
        e.preventDefault(); 
        return false;
      }

      // 1. Stato di caricamento visivo (non blocchiamo il comportamento nativo!)
      isSubmitting = true;
      submitBtn.classList.add('is-loading');
      radarInput.blur(); 
    });

    // Quando l'iframe carica significa che Shopify ha ricevuto e inviato la mail
    iframe.addEventListener('load', function() {
      if (isSubmitting) {
        const submitBtn = radarForm.querySelector('.koji-radar-submit');
        const successBox = radarForm.closest('.koji-radar-form-block').querySelector('.koji-radar-success');
        
        submitBtn.classList.remove('is-loading');
        
        // Nasconde il form fluidamente
        radarForm.classList.add('is-hidden');
        
        // Mostra il messaggio permanente e vibra
        setTimeout(() => {
          successBox.classList.add('is-active');
          if (navigator.vibrate) navigator.vibrate([30, 50, 30]); 
        }, 300);
        
        isSubmitting = false;
      }
    });
  });
});